<header>
  <h1><a href="https://github.com/tomwf/markdown-preview">Markdown Preview</a></h1>
</header>

<style lang="scss">
  $orange: rgb(228, 102, 70);

  header {
    text-align: center;
  }

  h1 {
    margin: .2em 0;
    font-family: 'Roboto Serif', serif;
    color: $orange;
  }
</style>
